const productType = [
  '银行理财产品', '保险产品', '信托计划', '私募投资基金', '开放式公募基金产品', '封闭式公募基金产品', '基金公司专户',
  '基金子公司产品', '保险公司及其子公司的资产管理计划', '证券公司集合理财产品', '证券公司专项资管计划', '证券公司定向资管计划',
  '期货公司及其子公司的资产管理计划', '政府引导基金', '全国社保基金', '地方社保基金', '基本养老保险', '养老金产品', '企业年金及职业年金',
  '境外资金（QFII）', '境外资金（RQFII）', '其它境外资金', '社会公益基金（慈善基金、捐赠基金等）', '其他产品',
];
export default productType;
